export default "__VITE_ASSET__CEWc69Qn__"